import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TabViewModule } from 'primeng/tabview';
import { CanDeactivateGuard } from './can-deactivate/can-deactivate-guard';
import { FilterAreaPipe } from './filters/filter-area.pipe';
import { FilterChapterPipe } from './filters/filter-chapter.pipe';
import { FilterdatePipe } from './filters/filter-date.pipe';
import { FilterExportedPipe } from './filters/filter-exported.pipe';
import { FilterLevelPipe } from './filters/filter-level.pipe';
import { FilterManuPipe } from './filters/filter-manu.pipe';
import { FilterPlacePipe } from './filters/filter-place.pipe';
import { FilterStatePipe } from './filters/filter-state.pipe';
import { FilterSupportMeasurePipe } from './filters/filter-support-measure.pipe';
import { FilterTypePipe } from './filters/filter-type.pipe';
import { NameFilterPipe } from './filters/name-filter.pipe';
import { FormDataResolver } from './forms/form-data-resolver.service';
import { TemplatePreviewComponent } from './forms/template-preview/template-preview.component';
import { TemplatesService } from './forms/templates.service';
import { OrderByPipe } from './order-by.pipe';
import { SettingsService } from './settings.service';
import { reducer } from './state/setting.reducer';
import { SettingsEffects } from './state/settings.effects';
import { StringReplaceTemplatePipe } from './string-replace.pipe';
import { TextReplacePipe } from './text-replace.pipe';
import { TranslatePipe } from './translate.pipe';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    TabViewModule,
    StoreModule.forFeature('settings', reducer),
    EffectsModule.forFeature([SettingsEffects])
  ],
  exports: [
    FormsModule, NameFilterPipe, OrderByPipe, TemplatePreviewComponent,
    FilterStatePipe, FilterLevelPipe, FilterAreaPipe, FilterTypePipe,
    FilterManuPipe, TranslatePipe, FilterPlacePipe, FilterSupportMeasurePipe,
    FilterChapterPipe, FilterdatePipe, FilterExportedPipe,
  ],
  declarations: [NameFilterPipe, OrderByPipe, TemplatePreviewComponent, TextReplacePipe,
    StringReplaceTemplatePipe, FilterStatePipe, FilterLevelPipe, FilterAreaPipe, FilterTypePipe,
    FilterManuPipe, TranslatePipe, FilterPlacePipe, FilterSupportMeasurePipe, FilterChapterPipe, FilterdatePipe, FilterExportedPipe,
  ],
  providers: [FormDataResolver, TemplatesService, SettingsService, CanDeactivateGuard, TranslatePipe]
})
export class SharedModule { }
